import React, { FC, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getEntityById, nullSafeGet } from '../../utils/DataAccessUtils';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { changeClientView } from '../../actions/client_view_actions';
import { isSubContractedWorkOrder } from '../../utils/WorkOrderUtils';

const SupplierWorkOrderSubcontractorNotesDetailPage: FC<any> = ({
	match,
	history,
	workOrdersFetching,
	updateClientView,
	workOrder,
	isClientView,
}): React.ReactElement => {
	const redirectUrl = `/supplier/workOrders/detail/${match.params.id}/contractor_notes`;

	const workOrderId = nullSafeGet(`id`, workOrder);
	useEffect(() => {
		if (workOrderId) {
			if (isSubContractedWorkOrder(workOrder)) {
				updateClientView(false);
			} else {
				updateClientView(true);
			}
			history.replace(`${redirectUrl}`);
		}
	}, [workOrderId, history, redirectUrl, updateClientView]);

	return workOrdersFetching ? (
		<Spin indicator={<LoadingOutlined style={{ fontSize: 16, color: '#fff' }} spin />} />
	) : null;
};

const mapStateToProps = (state, ownProps) => ({
	workOrdersFetching: state.work_orders.fetching,
	workOrder: getEntityById(ownProps.match.params.id, state.work_orders),
	isClientView: state.clientView.isClientView,
});

const mapDispatchToProps = (dispatch) => ({
	updateClientView: (isClientView) => dispatch(changeClientView(isClientView)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SupplierWorkOrderSubcontractorNotesDetailPage)
);
